// Single Page Apps for GitHub Pages
// https://github.com/rafgraph/spa-github-pages
// Copyright (c) 2016 Rafael Pedicini, licensed under the MIT License
//
// adapted to TS 2021 Jacek Kopecky
//
// ----------------------------------------------------------------------
// This script checks to see if a redirect is present in the query string
// and converts it back into the correct url and adds it to the
// browser's history using window.history.replaceState(...),
// which won't cause the browser to attempt to load the new url.
// When the single page app is loaded further down in this file,
// the correct url will be waiting in the browser's history for
// the single page app to route accordingly.

function redirect() {
  const l = window.location;

  if (l.search) {
    const q: Record<string, string> = {};
    l.search.slice(1).split('&').forEach((v) => {
      const a = v.split('=');
      q[a[0]] = a.slice(1).join('=').replace(/~and~/g, '&');
    });
    if (q.p !== undefined) {
      window.history.replaceState(
        null,
        '',
        l.pathname.slice(0, -1) + (q.p || '') + (q.q ? (`?${q.q}`) : '') + l.hash,
      );
    }
  }
}

redirect();
